export const decode = (str) => str.replace(/&#(\d+);/gm, (match, dec) => String.fromCharCode(dec))
